import { Col, Table } from "antd";

export default function Summary({ obShowData }) {
  return (
    <>
      <Col span={12}>
        <Table
          size="small"
          className="summary-table"
          dataSource={obShowData?.machine_summary}
          bordered
          columns={[
            {
              title: "NO",
              dataIndex: "no",
              key: "no",
              render: (text, record, index) => index + 1,
            },
            {
              title: "MACHINE SUMMARY",
              dataIndex: "machine_type_name",
              key: "machine_type_name",
            },
            {
              title: "QTY",
              dataIndex: "sum_machine_type_sam",
              key: "sum_machine_type_sam",
            },
          ]}
          pagination={false}
          summary={(pageData) => {
            if (pageData.length === 0) {
              return null;
            }
            let total = 0;
            pageData.forEach(({ sum_machine_type_sam }) => {
              total += sum_machine_type_sam;
            });

            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}>Sub Total</Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                  <strong>{total}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </Col>
      <Col span={12}>
        <Table
          size="small"
          className="summary-table"
          dataSource={
            obShowData?.summary?.ob_summary
              ? Object.entries(obShowData.summary.ob_summary).map(
                  ([key, value]) => {
                    return {
                      name: String(key).replace(/_/g, " "),
                      value: isNaN(parseFloat(value).toFixed(2))
                        ? value
                        : parseFloat(value).toFixed(2),
                    };
                  },
                )
              : []
          }
          bordered
          columns={[
            {
              title: "OB Summary",
              dataIndex: "name",
              key: "name",
              render: (text) => (
                <strong style={{ textTransform: "capitalize" }}>{text}</strong>
              ),
            },
            {
              title: "Value",
              dataIndex: "value",
              key: "value",
              align: "right",
            },
          ]}
          pagination={false}
        />
      </Col>
    </>
  );
}
